import { type FC, type ReactNode } from 'react'
import classNames from 'classnames'
import { IntegrationIcon } from '../../../components/IntegrationIcon'
import { Tooltip } from '../../../components/Tooltip/Tooltip'
import { type IntegrationServiceId } from '../../../common/integrations'

export interface IntegrationOptionRowProps {
  serviceId?: IntegrationServiceId
  label: string
  detail: ReactNode
  selected: boolean
  onSelect: () => void
}

export const IntegrationOptionRow: FC<IntegrationOptionRowProps> = ({ serviceId, label, detail, selected, onSelect }) => (
  <button
    type='button'
    role='radio'
    aria-checked={selected}
    aria-label={label}
    onClick={onSelect}
    className={classNames(
      'd-flex align-items-center gap-2 p-3 rounded-3 text-start border zocks-bg-color-white w-100',
      selected ? 'zocks-border-color-primary' : 'zocks-border-color-gray-300',
    )}
  >
    <i className={selected ? 'bi bi-record-circle-fill zocks-text-primary' : 'bi bi-circle zocks-text-gray-500'} />
    {serviceId ? <IntegrationIcon serviceId={serviceId} width='1.5rem' height='1.5rem' /> : null}
    <span className='d-flex flex-column overflow-hidden'>
      <span className='paragraph-small fw-bold zocks-text-gray-900 text-truncate'>{label}</span>
      <span className='paragraph-small'>{detail}</span>
    </span>
  </button>
)

export const ConnectedDetail: FC<{ email?: string }> = ({ email }) => (
  <span className='d-flex align-items-center paragraph-small overflow-hidden'>
    <span className='d-flex align-items-center zocks-gap-0.25 zocks-text-success text-nowrap flex-shrink-0'>
      <i className='bi bi-check' />
      Connected
    </span>
    {email ? (
      <>
        <i className='bi bi-dot zocks-text-gray-600' />
        <span className='zocks-text-gray-600 text-truncate'>{email}</span>
      </>
    ) : null}
  </span>
)

export const ReconnectDetail: FC<{ email?: string; tooltip: string }> = ({ email, tooltip }) => (
  <span className='d-flex align-items-center paragraph-small overflow-hidden'>
    <Tooltip tooltipContent={tooltip}>
      <span className='d-flex align-items-center zocks-gap-0.25 zocks-text-gray-600 text-nowrap flex-shrink-0'>
        <i className='bi bi-arrow-repeat' />
        Reconnect to use
      </span>
    </Tooltip>
    {email ? (
      <>
        <i className='bi bi-dot zocks-text-gray-600' />
        <span className='zocks-text-gray-600 text-truncate'>{email}</span>
      </>
    ) : null}
  </span>
)
